import { stringifyAuthQuery } from '@/lib/authQuery'
import { BACK_URL_QUERY_KEY, isUsableBackUrl } from '@/lib/backUrl'

export const AUTH_PUBLIC_BASE = import.meta.env.DEV ? '/' : '/auth/'

export function authPath(path: string): string {
  const normalized = path.startsWith('/') ? path.slice(1) : path
  return `${AUTH_PUBLIC_BASE}${normalized}`
}

/** Hard navigation href with fully encoded query (safe for absolute BACK_URL). */
export function buildAuthHref(
  path: string,
  query: Record<string, string | null | undefined> = {},
): string {
  const base = authPath(path)
  const filtered: Record<string, string> = {}
  for (const [key, value] of Object.entries(query)) {
    if (value == null || value === '') continue
    filtered[key] = value
  }
  const qs = stringifyAuthQuery(filtered)
  return qs ? `${base}?${qs}` : base
}

/**
 * Login URL for a new tab.
 * Do not use router.resolve().href — Vue Router leaves `:/` unencoded in query,
 * so absolute BACK_URL like https://domain/ breaks /auth/.
 */
export function buildLoginHref(backUrl?: string | null): string {
  if (!isUsableBackUrl(backUrl)) return authPath('')
  return buildAuthHref('', { [BACK_URL_QUERY_KEY]: backUrl })
}

/** Registration entry with trailing slash + encoded BACK_URL / REF_CODE. */
export function buildRegistrationHref(options?: {
  backUrl?: string | null
  refCode?: string | null
}): string {
  const query: Record<string, string> = {}
  if (options?.refCode) query.REF_CODE = options.refCode
  if (isUsableBackUrl(options?.backUrl)) query[BACK_URL_QUERY_KEY] = options.backUrl
  return buildAuthHref('registration/', query)
}
